export default __webpack_public_path__ + "static/media/juego4_perder.4daac9d2.png";